(function () {
    'use strict';

    angular
        .module('app.tasks')
        .controller('TasksController', TasksController);

    TasksController.$inject = ['$scope', 'common', 'dataservice', 'bootstrap.dialog', 'config', 'completions', 'notes', 'backendHubProxy' ];
    /* @ngInject */
    function TasksController($scope, common, dataservice, bsDialog, config, completions, notes, backendHubProxy) {
        var vm = this;
        vm.title = "Tasks"
        vm.items = [];
        vm.isLoading = true;
        vm.onDate = common.getMainState("mainDate");
        vm.showItemDetails = showItemDetails;
        vm.completions = completions;
        vm.notes = notes;
        vm.refresh = getItems;
        vm.canEdit = canEdit;
        vm.displayedItems = [];
        vm.hasCompletionType = completions.hasCompletionType;
        vm.showCompletionDot = showCompletionDot;
        vm.completionTypes = [];
        

        activate();

        $scope.$on('$destroy', function () {
            backendHubProxy.stop();
        });

        function activate() {
            backendHubProxy.displayedItems = vm.displayedItems;
            backendHubProxy.startListening();

            common.notifier.subscribe(common.config.events.mainDateChange, $scope, dateChanged);
            var promises = [getItems(), getCompletionTypes()];
            return common.$q.all(promises).then(function () {
                common.logger.info('Activated ' + vm.title + ' View');
                vm.isLoading = false;
                common.notifier.notify(config.events.refreshCounts);
            }, function (error) { });
        }

        function showCompletionDot(item) {
            return completions.isAllDone(item) || completions.isNothingCompleted(item, vm.completionTypes)
        }

        function showItemDetails(i) {
            return bsDialog.htmlBodyDialog(i.Description, i.Notes);
        }


        function canEdit(item) {
            if (common.userService.userType() == "0") {
                return common.userService.userId() == item.CreatedById;
            }
            else {
                return true;
            }
        }

        function getItems() {
            var m = moment(vm.onDate).format("YYYY-MM-DD");
            return dataservice.getItems('api/Tasks/GetForDate?forDate=' + m).then(function (response) {
                vm.items = response.data;
                backendHubProxy.items = vm.items;
                return vm.items;
            }, function (error) { });
        }

        function dateChanged(eventName, newDate) {
            vm.onDate = newDate;
            getItems();
        }

        function getCompletionTypes() {

            return dataservice.getItems('api/CompletionTypes').then(function (response) {
                vm.completionTypes = response.data;
                return vm.completionTypes;
            }, function (error) { });
        }

    }
})();
